import { render, staticRenderFns } from "./RoomRefuseBinding.vue?vue&type=template&id=2c837f9d&"
import script from "./RoomRefuseBinding.vue?vue&type=script&lang=js&"
export * from "./RoomRefuseBinding.vue?vue&type=script&lang=js&"
import style0 from "./RoomRefuseBinding.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports